module.exports = __webpack_public_path__ + "static/media/Antonio-Bano.ec74c3a8.jpg";